import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
  <div id="history">
    <div className="items-container">
      <h1>Career History</h1>
      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="Feb 2024 – Present"
          iconStyle={{ background: 'darkviolet', color: 'rgb(39, 40, 34)' }}
          icon={<FontAwesomeIcon icon={faBriefcase} />}
        >
          <h3 className="vertical-timeline-element-title">Software Engineer</h3>
          <h4 className="vertical-timeline-element-subtitle">K.G.N S.R.L, Vicenza, Italy</h4>
          <p>
            Built a PLC data communication system and web app for waste container interaction using Python, Django, AWS RDS/EC2, RealVNC. Implemented parallel programming for scalable KEP Server integration.
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="Apr 2023 – Present"
          iconStyle={{ background: 'darkviolet', color: 'rgb(39, 40, 34)' }}
          icon={<FontAwesomeIcon icon={faBriefcase} />}
        >
          <h3 className="vertical-timeline-element-title">Co-Founder</h3>
          <h4 className="vertical-timeline-element-subtitle">Nextrick, Remote</h4>
          <p>
            Co-founded an AI education initiative offering free, hands-on lectures. Focused on practical GenAI and experimental learning with industry professionals in remote environments.
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="Sep 2022 – Oct 2023"
          iconStyle={{ background: 'darkviolet', color: 'rgb(39, 40, 34)' }}
          icon={<FontAwesomeIcon icon={faBriefcase} />}
        >
          <h3 className="vertical-timeline-element-title">Teacher</h3>
          <h4 className="vertical-timeline-element-subtitle">H-Farm International Schools, Roncade, Italy</h4>
          <p>
            Taught C++ Programming and Web Development; supervised Machine Learning projects. Helped students build foundational skills in coding and AI.
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="May 2021 – May 2022"
          iconStyle={{ background: 'darkviolet', color: 'rgb(39, 40, 34)' }}
          icon={<FontAwesomeIcon icon={faBriefcase} />}
        >
          <h3 className="vertical-timeline-element-title">Surgical Data Scientist</h3>
          <h4 className="vertical-timeline-element-subtitle">WEISS, London, UK</h4>
          <p>
            Developed AI time-series models (Autoencoders, Transformers, LSTM, etc.) for Hydrocephalus patient activity recognition using Python, Pytorch, AWS Sagemaker, and tsai/fast.ai.
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="Aug 2018 – Jan 2019"
          iconStyle={{ background: 'darkviolet', color: 'rgb(39, 40, 34)' }}
          icon={<FontAwesomeIcon icon={faBriefcase} />}
        >
          <h3 className="vertical-timeline-element-title">Research Assistant</h3>
          <h4 className="vertical-timeline-element-subtitle">National University of Computer and Emerging Sciences, Lahore, Pakistan</h4>
          <p>
            Created an AR-based mobile app in Unity 3D to enhance children's education. Conducted research on AR adoption in learning environments.
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="May 2018 – Aug 2018"
          iconStyle={{ background: 'darkviolet', color: 'rgb(39, 40, 34)' }}
          icon={<FontAwesomeIcon icon={faBriefcase} />}
        >
          <h3 className="vertical-timeline-element-title">Software Engineer Intern</h3>
          <h4 className="vertical-timeline-element-subtitle">National University of Computer and Emerging Sciences, Lahore, Pakistan</h4>
          <p>
            Developed an AI-driven clash-free exam timetable using Genetic Algorithms to optimize scheduling under multiple constraints (capacity, back-to-back exams, and conflicts).
          </p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  </div>
);

}

export default Timeline;